import { render, staticRenderFns } from "./crudInstancesSystemOthers.vue?vue&type=template&id=2c4d9b2e&scoped=true"
import script from "./crudInstancesSystemOthers.vue?vue&type=script&lang=js"
export * from "./crudInstancesSystemOthers.vue?vue&type=script&lang=js"
import style0 from "./crudInstancesSystemOthers.vue?vue&type=style&index=0&id=2c4d9b2e&prod&lang=css"
import style1 from "./crudInstancesSystemOthers.vue?vue&type=style&index=1&id=2c4d9b2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4d9b2e",
  null
  
)

export default component.exports